import { ApiFetch } from '../../../shared/utils/fetch';
import type {
  ContentPage,
  ContentPagesListResponse,
  CreateContentPagePayload,
  UpdateContentPagePayload,
} from '../types';

/**
 * `/content-pages` is NOT in `fetch.ts`'s MERCHANT_SCOPED_PREFIXES or
 * TENANT_SCOPED_PREFIXES — it needs neither. The only scoping is the ambient
 * `x-tenant-id` header ApiFetch already attaches from `selectedTenantId`. Do not
 * add this path to either prefix list (see PE-2175 backend contract note).
 */
export const contentPagesApi = {
  list: () => ApiFetch.get<ContentPagesListResponse>('/content-pages'),
  get: (id: string) => ApiFetch.get<ContentPage>(`/content-pages/${id}`),
  create: (data: CreateContentPagePayload) => ApiFetch.post<ContentPage>('/content-pages', data),
  update: (id: string, data: UpdateContentPagePayload) => ApiFetch.put<ContentPage>(`/content-pages/${id}`, data),
  publish: (id: string) => ApiFetch.post<ContentPage>(`/content-pages/${id}/publish`, {}),
  remove: (id: string) => ApiFetch.del<void>(`/content-pages/${id}`),
};
